import actions from "@/store/modules/organisations/actions";
import mutations from "@/store/modules/organisations/mutations";
import getters from "@/store/modules/organisations/getters";
import organisationLocations from "@/store/modules/organisations/organisation-locations";
import organisationReasons from "@/store/modules/organisations/organisation-reasons";
import organisationSchedules from "@/store/modules/organisations/organisation-schedules";
import organisationUnits from "@/store/modules/organisations/organisation-units";
import organisationBookingTemplates from "@/store/modules/organisations/organisation-booking-templates";
import organisationMessageTemplates from "@/store/modules/organisations/organisation-message-templates";
import organisationInterviewFormatTemplates from "@/store/modules/organisations/organisation-interview-format-templates";
import organisationApplicationQuestionTemplates from "@/store/modules/organisations/organisation-application-question-templates";
import approvalChainTemplates from "@/store/modules/organisations/organisation-approval-chain-templates";

const state = {
  organisations: [],
  isOrganisationsLoading: false,
  rootClientOrganisations: [],
  rootAgencyOrganisations: []
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
  modules: {
    organisationSchedules,
    organisationReasons,
    organisationLocations,
    organisationUnits,
    organisationBookingTemplates,
    organisationMessageTemplates,
    organisationInterviewFormatTemplates,
    organisationApplicationQuestionTemplates,
    approvalChainTemplates
  }
};
